export class TokenStorage {

  static LOCAL_STORAGE_TOKEN = 'token';

  static isAuthenticated()
  {
    return this.getToken() !== null;
  }

  static getToken()
  {
    return localStorage.getItem(TokenStorage.LOCAL_STORAGE_TOKEN);
  }

  static storeToken(token)
  {
    localStorage.setItem(TokenStorage.LOCAL_STORAGE_TOKEN, token);
  }

  static clear()
  {
    localStorage.removeItem(TokenStorage.LOCAL_STORAGE_TOKEN);
  }
}
